import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';

import { modifierList } from './props-list';

const DEFAULT_TAG = 'div';

const SkeletonBlock = ({ skeletonColor, modifiers = [], tag = DEFAULT_TAG }) => {
  const classNames = getClassNames('c-skeleton-block', [skeletonColor, ...modifiers]);
  const Tag = tag;

  return <Tag className={classNames} />;
};

SkeletonBlock.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  skeletonColor: PropTypes.string.isRequired,
  tag: PropTypes.string,
};

export default SkeletonBlock;
